import { Box, CircularProgress, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import { getTasksDetails } from '_controllers/officer';

const messageStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#ffffff',
    border: "none",
    boxShadow: 24,
    pt: 2,
    pb: 0,
    pl: 4,
    pr: 4,
    textAlign: 'left',
    letterSpacing: 1
};

const Tasks = () => {
    const { SAP_ID } = useParams();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [visitDetails, setVisitDetails] = useState([])
    const [message, setMessage] = useState("");
    const [onDate, setOnDate] = useState('');
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [csvData, setCsvData] = useState([]);

    const [Values, setValues] = useState({
        selectStartDate: '',
        selectEndDate: '',
    });

    useEffect(async () => {
        const start = startDate
            ? startDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = endDate
            ? endDate
            : moment().endOf("month").format("YYYY-MM-DD");
        const plan = await getTasksDetails({
            SAP_ID,
            start,
            end,
        });
        setData(plan?.data);
        setCsvData(plan?.data)
        setLoading(true);
    }, [message]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setValues({ ...Values, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const plan = await getTasksDetails({
            SAP_ID,
            start: selectStartDate,
            end: selectEndDate,
        });
        setData(plan?.data);
        setCsvData(plan?.data)
        setLoading(true);
    }

    const { selectStartDate, selectEndDate } = Values
    const fileName = `${SAP_ID}-Tasks`;

    const generateExcel = async (e) => {
        e.preventDefault()

        exportExcel(csvData.map((x) => {
            return {
                'SAP ID': x?.SAP_ID,
                "Dealer Code": x.dealer.dealerCode,
                'Dealer Name': x.dealer.name,
                'Type': x.type,
                "Subject": x?.subject ? x?.subject : "-",
                'Status': x?.status,
                "Due Date": moment.utc(x?.dueDate).format("DD-MM-YYYY"),
                "Remarks": x?.description,
            }
        }), fileName)
    }

    return (
        <>
            {/* // change static data in url endpoint*/}
            <Box sx={{ mt: 2 }}>
                <form onSubmit={handleSubmit}>
                    <Grid container xs={12} sx={{ m: 1 }}>
                        <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={3}>
                                <h5>Start Date :</h5>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    type={'date'}
                                    sx={{ width: '80%' }}
                                    onChange={handleChange}
                                    value={selectStartDate}
                                    name="selectStartDate"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={3}>
                                <h5>End Date :</h5>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    type={'date'}
                                    sx={{ width: '80%' }}
                                    onChange={handleChange}
                                    value={selectEndDate}
                                    name="selectEndDate"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
                            <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
                        </Grid>
                    </Grid>
                </form>
            </Box>
            {loading ? (
                <>
                    <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Date</TableCell> */}
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer Code</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer Name</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Subject</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Status</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Due Date</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Remark</TableCell>
                                </TableRow>
                            </TableHead>

                            {data?.length > 0
                                ? data?.map((d) => (
                                    <TableBody>
                                        <TableRow key={d._id}>
                                            <TableCell align="left">{d?.dealer?.dealerCode}</TableCell>
                                            <TableCell align="left">{d?.dealer?.name}</TableCell>
                                            <TableCell align="left">{d?.type}</TableCell>
                                            <TableCell align="left">{d?.subject}</TableCell>
                                            <TableCell align="left">{d?.status}</TableCell>
                                            <TableCell align="left">
                                                {moment(d?.dueDate).format("DD-MM-YYYY")}
                                            </TableCell>
                                            <TableCell align="left">{d?.description}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                ))
                                :
                                <Box sx={{ textAlign: 'left', pt: 1 }}>
                                    <Typography variant="h6" sx={{ p: 1 }}>No Tasks Availabe.</Typography>
                                </Box>}
                        </Table>
                    </TableContainer>
                </>
            ) : (
                <CircularProgress />
            )}
            {/* <Modal open={open} onClose={handleClose}>
                <Box sx={messageStyle}>
                    <Table aria-label="simple table">
                        <TableHead >
                            <TableRow >
                                <TableCell align='left' sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                                <TableCell sx={{ fontWeight: 'bolder' }}>Action Taken</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {visitDetails?.length > 0 ? (
                                visitDetails.map((row) => (
                                    <TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="left" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.type}</TableCell>
                                        <TableCell align="center" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.actionTaken}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow key={'1'} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell colSpan={3} align="center">
                                        No Visit Action Available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Box sx={{ m: 3, display: 'flex', justifyContent: 'center' }}>
                        <Button variant="contained" onClick={() => setOpen(false)}>Close</Button>
                    </Box>
                </Box>
            </Modal> */}
        </>
    )
}

export default Tasks